import {CommonModule, NgOptimizedImage} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {NgxCaptchaModule} from 'ngx-captcha';
import {SidebarAdPlaceholderComponent} from '../components/ads/sidebar-ad-placeholder/sidebar-ad-placeholder.component';
import {StandardDfpBannerLoaderComponent} from '../components/ads/standard-dfp-banner-loader/standard-dfp-banner-loader.component';
import {StandardDfpBannerComponent} from '../components/ads/standard-dfp-banner/standard-dfp-banner.component';
import {AuthorBlockComponent} from '../components/author-block/author-block.component';
import {BreadcrumbsComponent} from '../components/breadcrumbs/breadcrumbs.component';
import {MediaItemComponent} from '../components/media-item/media-item.component';
import {AskComponent} from '../components/modals/ask/ask.component';
import {BecomeCustomerFormComponent} from '../components/modals/become-customer-form/become-customer-form.component';
import {BookComponent} from '../components/modals/book/book.component';
import {CustomBookComponent} from '../components/modals/custom-book/custom-book.component';
import {CustomerRateComponent} from '../components/modals/customer-rate/customer-rate.component';
import {DoktorseReceptComponent} from '../components/modals/doktorse-recept/doktorse-recept.component';
import {IframeModalComponent} from '../components/modals/iframe-modal/iframe-modal.component';
import {InfoModalComponent} from '../components/modals/info-modal/info-modal.component';
import {MessageModalComponent} from '../components/modals/message/message-modal.component';
import {RateComponent} from '../components/modals/rate/rate.component';
import {TreatmentDetailsModalComponent} from '../components/modals/treatment-details-modal/treatment-details-modal.component';
import {UpdateInfoFormComponent} from '../components/modals/update-info-form/update-info-form.component';
import {NotFoundComponent} from '../components/not-found/not-found.component';
import {BlogPuffComponent} from '../components/puffs/blog-puff/blog-puff.component';
import {BlogPuffsListComponent} from '../components/puffs/blog-puffs-list/blog-puffs-list.component';
import {CareServiceTypePagePuffComponent} from '../components/puffs/care-service-type-page-puff/care-service-type-page-puff.component';
import {GuidePuffComponent} from '../components/puffs/guide-puff/guide-puff.component';
import {GuidePuffsListComponent} from '../components/puffs/guide-puffs-list/guide-puffs-list.component';
import {NativePuffComponent} from '../components/puffs/native-puff/native-puff.component';
import {PagePuffComponent} from '../components/puffs/page-puff/page-puff.component';
import {SymptomPagePuffComponent} from '../components/puffs/symptom-page-puff/symptom-page-puff.component';
import {RateInputComponent} from '../components/rate-input/rate-input.component';
// tslint:disable-next-line:max-line-length
import {VardenBookingConfirmationV2Component} from '../components/modals/varden-booking-confirmation-v2/varden-booking-confirmation-v2.component';
import {SegmentIconComponent} from '../components/segment-icon/segment-icon.component';
import {SidebarPuffsListComponent} from '../components/sidebar/sidebar-puffs-list/sidebar-puffs-list.component';
import {SidebarComponent} from '../components/sidebar/sidebar.component';
import {SpinnerComponent} from '../components/spinner/spinner.component';
import {StarRatingComponent} from '../components/star-rating/star-rating.component';
import {BannerHostDirective} from '../directives/banner-host.directive';
import {MapHostDirective} from '../directives/map-host.directive';
import {StaticAdClickDirective} from '../directives/static-ad-click.directive';
import {AnchorLinksUrlFixPipe} from '../pipes/anchor-links-url-fix.pipe';
import {FilterPipe} from '../pipes/filter.pipe';
import {SafeHtmlPipe} from '../pipes/savehtml.pipe';
import {SafeUrlPipe} from '../pipes/saveurl.pipe';
import {WpMediaUrlFixPipe} from '../pipes/wp-media-url-fix.pipe';
import {SpinnerCircleComponent} from '../components/spinner/spinner-circle/spinner-circle.component';
import {DfpModule, GPT_LOADER, GPT_SOURCE} from '@wwei/dfp';
import {of} from 'rxjs';
import {RoundPipe} from '../pipes/round.pipe';
import {SharedTrackingModule} from './shared-tracking.module';
import {MatDialogActions, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {TelephoneComponent} from '../components/careprovider/telephone/telephone.component';
import {AfterRenderDirective} from '../directives/after-render.directive';
import {FormatNumberPipe} from '../pipes/format-number.pipe';
import {MarkdownPipe} from '../pipes/markdown.pipe';
import {UiIconComponent} from '../components/ui/ui-icon/ui-icon.component';
import {UiButtonComponent} from '../components/ui/ui-button/ui-button.component';
import {UiIconButtonComponent} from '../components/ui/ui-icon-button/ui-icon-button.component';
import {IndexedLinkDirective} from '../directives/indexed-link.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    RouterModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatExpansionModule,
    DfpModule,
    // ListaDigWidgetWrapperModule,
    NgOptimizedImage,
    SharedTrackingModule,
    MatDialogActions,
    UiIconComponent,
    UiButtonComponent,
    UiIconButtonComponent,
    MatDialogTitle,
    MatDialogContent,
  ],
  declarations: [
    FilterPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    WpMediaUrlFixPipe,
    AnchorLinksUrlFixPipe,
    RoundPipe,
    SidebarComponent,
    NativePuffComponent,
    BreadcrumbsComponent,
    NotFoundComponent,
    BlogPuffComponent,
    StandardDfpBannerComponent,
    StandardDfpBannerLoaderComponent,
    BannerHostDirective,
    MapHostDirective,
    DoktorseReceptComponent,
    StaticAdClickDirective,
    MediaItemComponent,
    GuidePuffComponent,
    BlogPuffsListComponent,
    GuidePuffsListComponent,
    AskComponent,
    BecomeCustomerFormComponent,
    BookComponent,
    CustomBookComponent,
    MessageModalComponent,
    RateComponent,
    CustomerRateComponent,
    UpdateInfoFormComponent,
    RateInputComponent,
    // ListaDigHsaModalComponent,
    InfoModalComponent,
    AuthorBlockComponent,
    IframeModalComponent,
    // MobileFullscreenPopupComponent,
    PagePuffComponent,
    // DoktorseReceptBannerComponent,
    SidebarAdPlaceholderComponent,

    StarRatingComponent,
    // AreYouListedModalComponent,
    SpinnerComponent,
    TreatmentDetailsModalComponent,
    VardenBookingConfirmationV2Component,
    SegmentIconComponent,
    SidebarPuffsListComponent,
    CareServiceTypePagePuffComponent,
    SymptomPagePuffComponent,
    SpinnerCircleComponent,
    TelephoneComponent,
    AfterRenderDirective,
    FormatNumberPipe,
    MarkdownPipe,
    IndexedLinkDirective,
  ],
  bootstrap: [],
  providers: [
    {
      provide: GPT_LOADER,
      useValue: of(GPT_SOURCE.LIMITED_ADS),
    },
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FilterPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    WpMediaUrlFixPipe,
    AnchorLinksUrlFixPipe,
    RoundPipe,
    SidebarComponent,
    NativePuffComponent,
    BreadcrumbsComponent,
    NotFoundComponent,
    BlogPuffComponent,
    StandardDfpBannerComponent,
    StandardDfpBannerLoaderComponent,
    BannerHostDirective,
    MapHostDirective,
    NgxCaptchaModule,
    DoktorseReceptComponent,
    StaticAdClickDirective,
    MediaItemComponent,
    GuidePuffComponent,
    BlogPuffsListComponent,
    GuidePuffsListComponent,
    AskComponent,
    BecomeCustomerFormComponent,
    BookComponent,
    CustomBookComponent,
    MessageModalComponent,
    RateComponent,
    CustomerRateComponent,
    UpdateInfoFormComponent,
    RateInputComponent,
    // ListaDigHsaModalComponent,
    InfoModalComponent,
    AuthorBlockComponent,
    IframeModalComponent,
    // MobileFullscreenPopupComponent,
    PagePuffComponent,
    // DoktorseReceptBannerComponent,
    SidebarAdPlaceholderComponent,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatExpansionModule,
    StarRatingComponent,
    // AreYouListedModalComponent,
    SpinnerComponent,
    TreatmentDetailsModalComponent,
    VardenBookingConfirmationV2Component,
    SegmentIconComponent,
    SidebarPuffsListComponent,
    SpinnerCircleComponent,
    DfpModule,
    NgOptimizedImage,
    SharedTrackingModule,
    TelephoneComponent,
    AfterRenderDirective,
    FormatNumberPipe,
    MarkdownPipe,
    IndexedLinkDirective,
  ],
})
export class SharedModule {}
